<template>
    <transition name="slide-in" appear>
            <!-- Контейнер модального окна -->
                <div v-if="message.length" class="modal__container">
                    <div class="modal__body">
                        <p 
                            v-for="(item, index) in message"
                            :key="index">{{ item }}</p>
                    </div>
                    <span @click="modalClose" class="icon-cross modal__close-icon"></span>
                </div>
            <!-- End Контейнер модального окна -->
    </transition>
</template>

<script>
export default {
    name: 'ModalNotification',

    computed: {
        message() {
            return this.$store.getters['modalNotificationMessage']
        }
    },
    methods: {
        modalClose() {
            this.$store.dispatch('modalNotificationMessageClose')
        }
    }
}
</script>

<style lang="sass" scoped>
.modal__container
    position: fixed

    background-color: #fff

    bottom: 20px
    right: 20px

    width: 400px
    padding: 20px

    box-shadow: 0px 4px 6px 1px rgba(#000, .4)

    z-index: 10000

    .modal__body

    .modal__close-icon
        position: absolute

        top: 10px
        right: 10px

.slide-in-enter-active
    animation: slide-in .5s ease forwards

@keyframes slide-in
    from
        opacity: 0
        transform: translateY(25px)
    to
        transform: translateY(0)
        opacity: 1

@keyframes slide-out
    from
        opacity: 1
        transform: translateY(0)
    to
        transform: translateY(-25px)
        opacity: 0
</style>